import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _styled3 from "styled-components";
import _styled2 from "styled-components";
import _styled from "styled-components";
const _excluded = ["id", "name", "description", "price", "formatedPrice", "i18n", "onClick", "disabledAction", "cursor", "isDisabled", "isSelected", "isBottleService", "isCheckbox"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import css from '@styled-system/css';
import propTypes from '@styled-system/prop-types';
import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';
import { Card } from '../Cards';
import { Checkbox } from '../Inputs/Checkbox';
import { Col, Flex, Row } from '../Layout';
import { Text, TypographyBase } from '../Typography';
const Name = _ref => {
  let {
    msg
  } = _ref;
  return React.createElement(TypographyBase, {
    color: "text.primary",
    mr: 3,
    fontSize: 16,
    lineHeight: 1.5,
    fontWeight: "900"
  }, msg);
};
const Description = _ref2 => {
  let {
    msg
  } = _ref2;
  return React.createElement(_StyledTypographyBase, {
    color: "text.secondary",
    mt: "3px",
    fontSize: 14,
    lineHeight: 1.43,
    fontWeight: "normal"
  }, msg);
};
const PriceText = styled(Text).withConfig({
  displayName: "PriceText",
  componentId: "sc-1y7kf5k-0"
})(["&&&{margin:0;text-align:right;}"]);
var _StyledPriceText2 = styled(PriceText).withConfig({
  displayName: "_StyledPriceText2",
  componentId: "sc-1y7kf5k-1"
})(["", ""], p => p.$_css2);
var _StyledPriceText = styled(PriceText).withConfig({
  displayName: "_StyledPriceText",
  componentId: "sc-1y7kf5k-2"
})(["", ""], p => p.$_css);
const CheckIconSmall = styled.svg.withConfig({
  displayName: "CheckIconSmall",
  componentId: "sc-1y7kf5k-3"
})(["width=12  height=8  viewBox=0 0 12 8"]);
const CheckIcon = React.createElement(CheckIconSmall, null, React.createElement("path", {
  transform: "translate(3, 4.5)",
  d: "M1.5 3.762 4.714 6.53a1 1 0 0 0 1.431-.13L10.5 1",
  stroke: "#FFF",
  strokeWidth: "2",
  fill: "none",
  fillRule: "evenodd"
}));
const RadioInnerCircleIcon = isChecked => React.createElement(CheckIconSmall, null, React.createElement("circle", {
  cx: "9",
  cy: "9",
  r: "9",
  fill: isChecked ? '#3b90fd' : 'none'
}), React.createElement("circle", {
  cx: "9",
  cy: "9",
  r: "7",
  fill: isChecked ? 'white' : 'none'
}), React.createElement("circle", {
  cx: "9",
  cy: "9",
  r: "5",
  fill: isChecked ? '#3b90fd' : 'none'
}));
export const AddOn = React.forwardRef((props, ref) => {
  const {
      id,
      name,
      description,
      price,
      formatedPrice,
      i18n,
      onClick,
      disabledAction,
      cursor,
      isDisabled,
      isSelected,
      isBottleService,
      isCheckbox
    } = props,
    rest = _objectWithoutProperties(props, _excluded);
  const Price = React.createElement(_StyledPriceText, {
    marginTop: "3px",
    fontWeight: 900,
    fontSize: "14px",
    color: "#36424a",
    lineHeight: 1,
    fontStyle: isDisabled ? 'italic' : 'inherit',
    $_css: isDisabled && css({
      'text-decoration': 'line-through'
    })
  }, "+ ", formatedPrice);
  const PriceLabel = React.createElement(_StyledPriceText2, {
    fontSize: "12px",
    fontWeight: 300,
    color: "#6e7a83",
    lineHeight: "11px",
    fontStyle: isDisabled ? 'italic' : 'inherit',
    $_css2: isDisabled && css({
      'text-decoration': 'line-through'
    })
  }, isBottleService ? i18n.bookingText : i18n.personText);
  const handleClick = () => {
    onClick({
      id,
      isChecked: !isSelected,
      price,
      name
    });
  };
  const handleKeyDown = event => {
    if (event.key === 'Enter') {
      onClick({
        id,
        isChecked: !isSelected,
        price,
        name
      });
    }
  };
  const handleClickCheck = event => {
    event.stopPropagation();
  };
  const handleKeyDownCheck = event => {
    if (event.key === 'Enter') {
      event.stopPropagation();
    }
  };
  return React.createElement(Card, _extends({
    opacity: isDisabled ? '0.4' : undefined,
    onClick: isDisabled ? disabledAction : handleClick,
    onKeyDown: handleKeyDown,
    borderColor: isSelected ? '#3b90fd' : 'transparent',
    paddingX: [2, 3],
    paddingY: 18,
    ref: ref,
    cursor: cursor,
    overflow: "hidden",
    tabIndex: 0
  }, rest), React.createElement(Row, {
    alignItems: "center"
  }, React.createElement(Col, {
    flex: 1,
    maxWidth: "44px"
  }, React.createElement(Checkbox, {
    checked: isSelected,
    checkSize: "20px",
    circularCheck: !isCheckbox,
    activeCheckColor: isCheckbox ? '#3b90fd' : 'white',
    checkIcon: isCheckbox ? CheckIcon : RadioInnerCircleIcon(isSelected),
    onClick: handleClickCheck,
    handleKeyDown: handleKeyDownCheck,
    tabIndex: -1,
    onChange: () => {}
  })), React.createElement(Col, {
    flex: 1,
    paddingX: [0, 2]
  }, React.createElement(Flex, {
    justifyContent: "space-between",
    alignItems: ['baseline', 'center', 'center']
  }, React.createElement(Flex, {
    flex: 1,
    flexDirection: ['column', 'inherit'],
    alignItems: ['flex-start', 'center']
  }, React.createElement(Flex, null, React.createElement(Name, {
    msg: name
  })))), React.createElement(Description, {
    msg: description
  })), React.createElement(Col, {
    alignSelf: "flex-start",
    width: "auto",
    display: ['block']
  }, React.createElement(Flex, {
    flexDirection: "column"
  }, Price, PriceLabel))));
});
AddOn.propTypes = process.env.NODE_ENV !== "production" ? _objectSpread(_objectSpread({}, propTypes.space), {}, {
  name: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  price: PropTypes.number.isRequired,
  formatedPrice: PropTypes.string.isRequired,
  onClick: PropTypes.func,
  disabledAction: PropTypes.func,
  cursor: PropTypes.string,
  i18n: PropTypes.shape({
    personText: PropTypes.string,
    bookingText: PropTypes.string
  }).isRequired,
  isDisabled: PropTypes.bool,
  isSelected: PropTypes.bool,
  isBottleService: PropTypes.bool.isRequired,
  isCheckbox: PropTypes.bool
}) : {};
AddOn.defaultProps = {
  onClick: () => {},
  disabledAction: () => {},
  cursor: 'pointer',
  isDisabled: false,
  isSelected: false,
  isCheckbox: false
};
Description.propTypes = process.env.NODE_ENV !== "production" ? {
  msg: PropTypes.string.isRequired
} : {};
Name.propTypes = process.env.NODE_ENV !== "production" ? {
  msg: PropTypes.string.isRequired
} : {};
var _StyledTypographyBase = styled(TypographyBase).withConfig({
  displayName: "_StyledTypographyBase",
  componentId: "sc-1y7kf5k-4"
})(["white-space:pre-line;"]);